import { useBoolean } from 'ahooks';
import { Col, Row } from 'antd';
import { TreeSelectProps } from 'antd/lib';

import { EditAction, MilesText } from 'components';

import { AggregatedProductIdentity, ProductIdentityValue } from 'codegen';

import { EditIdentityModal } from './EditIdentityModal';

export const IdentityValue = ({
  record,
  identity,
  retailers,
  refresh,
}: {
  record: AggregatedProductIdentity & { id: number };
  identity: ProductIdentityValue;
  retailers: TreeSelectProps['treeData'],
  refresh: () => void;
}) => {
  const [isEdit, { setTrue, setFalse }] = useBoolean(false);

  return (
    <Row align='middle' wrap={false} justify='space-between'>
      <EditIdentityModal
        open={isEdit}
        record={record}
        identity={identity}
        retailers={retailers}
        refresh={refresh}
        onCancel={setFalse}
      />

      <Col>
        <MilesText disabled={!identity.isActive}>{identity.value}</MilesText>
      </Col>

      <Col>
        <EditAction
          onClick={setTrue}
          disabled={!identity.isActive}
        />
      </Col>
    </Row>
  );
};
